import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BookOpen } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { NeuButton } from "../components/neu/Neu";
import { docsUrl, listDeliveries, listEvents, listKeys, listWebhooks } from "../api/admin";
import { ApiKeyPanel } from "../features/admin/ApiKeyPanel";
import { WebhookPanel } from "../features/admin/WebhookPanel";
import { IntegrationGuide } from "../features/admin/IntegrationGuide";

export default function ApiAccessPage() {
  const { t } = useTranslation();
  const [state, setState] = useState({ keys: [], hooks: [], events: [], deliveries: [] });

  const load = async () => {
    const [keys, hooks, events, deliveries] = await Promise.all([
      listKeys(),
      listWebhooks(),
      listEvents(),
      listDeliveries(),
    ]);
    setState({ keys, hooks, events, deliveries });
  };
  useEffect(() => {
    load();
  }, []);

  return (
    <AppShell
      title={t("api.title")}
      subtitle={t("api.subtitle")}
      actions={
        <NeuButton
          data-testid="swagger-link"
          className="flex items-center gap-2"
          onClick={() => window.open(docsUrl, "_blank", "noopener")}
        >
          <BookOpen className="h-4 w-4" /> {t("api.docs")}
        </NeuButton>
      }
    >
      <div className="grid min-w-0 gap-6">
        <IntegrationGuide baseUrl={process.env.REACT_APP_BACKEND_URL} />
        <ApiKeyPanel keys={state.keys} reload={load} />
        <WebhookPanel hooks={state.hooks} events={state.events} deliveries={state.deliveries} reload={load} />
      </div>
    </AppShell>
  );
}
